<template>
	<div class="company-page">
		<!-- 顶部横幅 -->
		<section class="banner-section">
			<img src="@/assets/pic/company-ban.jpg" alt="公司介绍" class="banner-img" />
			<div class="banner-overlay"></div>
			<div class="banner-content">
				<h1 class="banner-title">{{ $i18n.t('company.companyName') }}</h1>
				<p class="banner-subtitle">Invision Asset Management International Limited</p>
			</div>
		</section>

		<!-- 主内容区域：左文字 / 右图片+卡片 -->
		<section class="main-section">
			<div class="container">
				<!-- 区域标题 -->
				<div class="section-header scroll-animate fade-up" data-delay="0">
					<h2 class="secTitle">{{ $i18n.t('company.introTitle') }}</h2>
					<span>{{ $i18n.t('company.profileSub') }}</span>
				</div>

				<div class="content-grid">
					<!-- 左侧文字 -->
					<div class="content-left">
						<!-- 公司简介 -->
						<div class="intro-block scroll-animate fade-up" data-delay="100">
							<h3>{{ $i18n.t('company.introTitle') }}</h3>
							<p>{{ $i18n.t('company.introFull1') }}</p>
						</div>

						<!-- 产品介绍 -->
						<div class="product-block scroll-animate fade-up" data-delay="200">
							<h3>{{ $i18n.t('product.productTitle') }}</h3>
							<p>{{ $i18n.t('product.descFull') }}</p>
							<br/>
							<p>{{ $i18n.t('product.descFull2') }}</p>
							<br/>
							<p>{{ $i18n.t('product.descFull3') }}</p>
						</div>
					</div>

					<!-- 右侧图片+卡片 -->
					<div class="content-right">
						<div class="image-wrapper scroll-animate fade-right" data-delay="100">
							<img src="@/assets/pic/5.jpg" alt="公司图片" class="right-image" />
							<div class="image-overlay">
								<span class="overlay-title">{{ $i18n.t('stats.compliance') }}</span>
								<span class="overlay-desc">{{ $i18n.t('stats.license') }}</span>
							</div>
						</div>

						<!-- 统计卡片 -->
						<div class="stats-grid">
							<div class="stat-item scroll-animate fade-up" v-for="(stat, index) in stats" :key="index"
								:data-delay="(index + 1) * 150">
								<div class="stat-value">{{ stat.value }}</div>
								<div class="stat-label">{{ $i18n.t(stat.labelKey) }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script setup>
	import {
		useScrollAnimation
	} from '../composables/useScrollAnimation'
	useScrollAnimation()

	const stats = [{
			value: '20+',
			labelKey: 'stats.exchanges'
		},
		{
			value: '2021',
			labelKey: 'stats.founded'
		},
		{
			value: '5×24',
			labelKey: 'stats.coverage'
		}
	]
</script>

<style scoped>
	.company-page {
		min-height: 100vh;
	}

	/* 横幅区域 */
	.banner-section {
		position: relative;
		width: 100%;
		/* height: 25rem; */
		overflow: hidden;
	}

	.banner-overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: linear-gradient(to right, rgba(0, 20, 40, 0.9) 0%, rgba(0, 20, 40, 0.8) 60%, transparent 100%);
		pointer-events: none;
		z-index: 1;
	}

	.banner-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.banner-content {
		position: absolute;
		top: 50%;
		left: 12rem;
		transform: translateY(-50%);
		z-index: 2;
	}

	.banner-title {
		font-size: 3rem;
		font-weight: bold;
		color: #fff;
		margin-bottom: 0.75rem;
		letter-spacing: 0.125rem;
	}

	.banner-subtitle {
		font-size: 1rem;
		color: rgba(255, 255, 255, 0.85);
		letter-spacing: 0.1875rem;
	}

	/* 容器 */
	.container {
		max-width: 87rem;
		margin: 0 auto;
		padding: 0 1.25rem;
	}

	/* 区域标题 - 居中+短线 */
	.section-header {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 3rem;
	}

	.secTitle {
		font-size: 1.75rem;
		font-weight: bold;
		color: #1a3a5c;
		display: inline-block;
		position: relative;
		padding-bottom: 1.1rem;
		margin-bottom: 0;
	}

	.secTitle::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 3rem;
		height: 0.1875rem;
		background-color: #4779B5;
		border-radius: 0.0625rem;
	}

	.section-header span {
		font-size: 1rem;
		color: #999;
		letter-spacing: 0.125rem;
		margin-top: 0.625rem;
	}

	/* 主内容区域 */
	.main-section {
		padding: 5rem 0;
		background-color: #fff;
	}

	/* 左右两栏布局 */
	.content-grid {
		display: grid;
		grid-template-columns: 1.2fr 1fr;
		gap: 3.75rem;
	}

	/* ====== 左侧文字栏 ====== */
	.content-left {
		display: flex;
		flex-direction: column;
		gap: 2.5rem;
	}

	.intro-block,
	.product-block {
		border-left: 0.1875rem solid #4779B5;
		padding-left: 1.875rem;
	}

	.intro-block h3,
	.product-block h3 {
		font-size: 1.125rem;
		font-weight: bold;
		color: #1a3a5c;
		margin-bottom: 1rem;
	}

	.intro-block p,
	.product-block p {
		font-size: 1.2rem;
		line-height: 2;
		color: #555;
		text-align: justify;
	}

	/* ====== 右侧图片+卡片栏 ====== */
	.content-right {
		display: flex;
		flex-direction: column;
		gap: 1.875rem;
	}

	/* 图片容器 */
	.image-wrapper {
		position: relative;
		border-radius: 0.5rem;
		overflow: hidden;
	}

	.right-image {
		width: 100%;
		height: auto;
		display: block;
		border-radius: 0.5rem;
	}

	.image-overlay {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 1.25rem 1.5rem;
		background: linear-gradient(to top, rgba(26, 58, 92, 0.9) 0%, transparent 100%);
		display: flex;
		flex-direction: column;
		gap: 0.125rem;
	}

	.overlay-title {
		font-size: 1rem;
		font-weight: bold;
		color: #fff;
	}

	.overlay-desc {
		font-size: 0.75rem;
		color: rgba(255, 255, 255, 0.75);
	}

	/* 统计卡片 - 横向排列 */
	.stats-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 1.25rem;
	}

	.stat-item {
		display: block;
		position: relative;
		overflow: hidden;
		padding: 1.25rem 1.5rem;
		border-radius: 0.375rem;
		border-left: 0.1875rem solid #4779B5;
		background: #F5F7FA;
		transition: all 0.3s ease;
	}

	.stat-item:hover {
		transform: translateY(-0.1875rem);
		box-shadow: 0 0.625rem 1.5rem rgba(71, 121, 181, 0.12);
	}

	.stat-value {
		font-size: 1.75rem;
		font-weight: bold;
		color: #4779B5;
		margin-bottom: 0.375rem;
	}

	.stat-label {
		font-size: 1rem;
		color: #666;
		line-height: 1.4;
	}

	/* 响应式设计 */
	@media (max-width: 48rem) {
		.banner-section {
			height: 17.5rem;
		}

		.banner-content {
			left: 1.875rem;
		}

		.banner-title {
			font-size: 1.5rem;
		}

		.banner-subtitle {
			font-size: 0.75rem;
			letter-spacing: 0.25rem;
		}

		.content-grid {
			grid-template-columns: 1fr;
			gap: 2.5rem;
		}

		.stats-grid {
			grid-template-columns: repeat(3, 1fr);
			gap: 0.75rem;
		}

		.main-section {
			padding: 3.125rem 0;
		}
	}

	@media (max-width: 30rem) {
		.stats-grid {
			grid-template-columns: repeat(2, 1fr);
		}

		.banner-title {
			font-size: 1.5rem;
		}
	}
</style>